const setProductGallery = (images, imageSwiper, thumbSwiper, imageLoader) => {
  const swiperGallery = document.querySelector('.snep-swiper-gallery') as HTMLElement;
  const galleryWrapper = swiperGallery.querySelector('.swiper-wrapper') as HTMLElement;
  const thumbGallery = document.querySelector('.snep-swiper-thumbs') as HTMLElement;
  const thumbWrapper = thumbGallery.querySelector('.swiper-wrapper') as HTMLElement;
  const imageSwiperVar = imageSwiper;
  const thumbSwiperVar = thumbSwiper;

  // Empty the gallery
  galleryWrapper.innerHTML = '';
  thumbWrapper.innerHTML = '';

  // Loop through all images
  [...images].forEach((image) => {
    imageSwiper.appendSlide(`<div class="swiper-slide"><img src="${image.src}" alt="${image.alt}" /></div>`);
    thumbSwiper.appendSlide(`<div class="swiper-slide"><img src="${image.src}" alt="${image.alt}" /></div>`);
    window.dispatchEvent(new Event('resize'));
  });

  imageSwiperVar.activeIndex = 1;
  thumbSwiperVar.activeIndex = 0;

  imageSwiper.update();
  thumbSwiper.update();

  // Remove the loader
  imageLoader.classList.remove('snep-image-loader--active');
};

export default setProductGallery;
